import React from "react";
import { useTranslation } from "react-i18next";

import LanguageTable from "../../../Common/LanguageTable";
import { LegalTextConfig } from "../constants";

interface Props {
    basePath: string[];
    legalText: any;
    defaultLegalText: LegalTextConfig;
    mainColor: string;
    updatePath: (path: string[], value: any) => void;
}

export function LegalTextSection({
    basePath,
    legalText,
    defaultLegalText,
    mainColor,
    updatePath,
}: Props) {
    const { t } = useTranslation();

    return (
        <div
            data-testid="legal-text-section"
            style={{
                padding: 16,
                border: "1px solid #e0e0e0",
                borderRadius: 8,
            }}
        >
            <h6
                style={{
                    fontWeight: 700,
                    fontSize: 15,
                    marginBottom: 16,
                    color: mainColor,
                    textTransform: "uppercase",
                }}
            >
                {t("Legal text")}
            </h6>

            <LanguageTable
                path={[...basePath, "LegalText"]}
                fields={[
                    {
                        key: "Content",
                        label: "Legal text",
                        placeholder: "Enter legal text",
                        isVisible: legalText?.Visible ?? true,
                        onVisibilityToggle: () =>
                            updatePath(
                                [...basePath, "LegalText", "Visible"],
                                !(legalText?.Visible ?? true)
                            ),
                    },
                ]}
                defaultTexts={defaultLegalText}
                sectionTitle={t("Legal notice")}
            />
        </div>
    );
}
